export default __webpack_public_path__ + "e84c048b614e5f55978ac466df11c6cd.jpg";